import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({
	selector: "[appAutomataTemplate]"
})
export class AutomataTemplateDirective {
	@Input() type!: string;

	@Input("appAutomataTemplate") name!: string;

	constructor(public template: TemplateRef<unknown>) {}

	getType(): string {
		return this.name;
	}
}
